// src/components/AuthGuard.js
import { navigate } from "gatsby";
import { useAuth } from "./auth-context";

// Define explicitly protected routes
const protectedPaths = [
  "/downloads",
  "/video-gallery",
  "/supertrump-desktop-online-training",
  "/supertrump-new-desktop-online-training",
  "/supertrump-salesforce-online-training",
  "/supertrump-web-online-training",
  // add additional exact paths here
];

export default function AuthGuard({ element, props }) {
  const {userState} = useAuth();
  const path = props.location.pathname;

  const isProtected = protectedPaths.includes(path.replace(/\/$/, ""));
  
  if (isProtected && typeof window !== "undefined" && !userState?.token) {
    navigate("/login", { replace: true });
    return null; // Prevents unnecessary Spinner render
  }

  return element;
}
